export default __webpack_public_path__ + "static/media/logo_with_text.c539d7da.svg";